// removed by extract-text-webpack-plugin
module.exports = {"stats-wrapper":"stats-wrapper___3lPDo center___2iqBf","stats":"stats___k_7jk center___2iqBf padding-bottom-5___2nauS","stat":"stat___Wl6tX","stat-count-wrapper":"stat-count-wrapper___2SBNN center___2iqBf","stat-count":"stat-count___DV4FS center___2iqBf","stat-label":"stat-label___1BNK4 h5___l1yk7","stats-info":"stats-info___1WFIv h3___5u0xZ space-top-10___1FChW space-bottom-6___3i22S","view-more-data":"view-more-data___eIsIF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FlaggedFund/FlaggedFund.css
// module id = 858
// module chunks = 0